export const GET_AUTH_DATA = 'GET_AUTH_DATA';